import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: nowrap;
    height: auto;

    color: ${({ theme }) => theme.text};
    font-size: 11px;
    text-align: center;
    font-family: 'Atlas Grotesk Medium', sans-serif;
    letter-spacing: -0.04px;
    border-spacing: 0;
    margin: 10px;
    padding: 15px 0;
`;

const SegmentContainer = styled.div`
    flex: 1 1 0%;
    width: 0;
    font: inherit;
    color: inherit;
`;

export { Container, SegmentContainer };
